// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import {
  BurnRequest,
  BurnRequest_Reject,
} from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import { ContractId } from '@daml/types';
import { ERR_REJ_BURN, SUC_REJ_BURN } from '../../../../utils/strings';

interface Args {
  burnRequestId: ContractId<BurnRequest>;
  reason?: string;
}

export const useRejectBurnRequest2Step = () => {
  const { submit: rejectBurnRequest } = useExerciseSubmission(
    BurnRequest.BurnRequest_Reject,
    SUC_REJ_BURN,
    ERR_REJ_BURN,
  );

  return async (args: Args) => {
    const { burnRequestId } = args;

    const payload: BurnRequest_Reject = {
      reason: args.reason || '',
      extraArgs: null,
    };

    const disclosedContracts: never[] = [];

    await rejectBurnRequest({
      cid: burnRequestId,
      argument: payload,
      meta: {
        disclosedContracts,
      },
    });
  };
};
